import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import { HoldAndSpinRecord } from "ags/integration/records/hold-and-spin-record";

export default class LLIsRecoveryFreespins extends Decision {
    public evaluate() {
        const gameplay = GameState.getCurrentGame();

        const isRecovery = gameplay.isRecovered;
        const isHoldAndSpin = gameplay.getCurrentRecord() instanceof HoldAndSpinRecord;
        const isFreespins = GameState.getCurrentGame().areFreespinsPending() && GameState.getCurrentGame().getFreespinsPlayed() > 0;

        return isRecovery && !isHoldAndSpin && isFreespins  ? Exit.True : Exit.False;
    }
}
